export default "__VITE_ASSET__C4aL328U__"